// localStorage values
export const SCOPE = {
    TECH:    'tech',
    FINANCE: 'finance'
} as const;

export const LANGUAGE = {
    DE: 'de',
    EN: 'en'
} as const;

// Helper types
type LocalStorageObjectValue<T> = T[keyof T] | null


export type ScopeValue = LocalStorageObjectValue<typeof SCOPE>
export type LanguageValue = LocalStorageObjectValue<typeof LANGUAGE>